import { useRef } from "react"
import { useAnimationFrame } from "../util"

import useStore from "../AppStore"

export default function Debug (props) {
  const scrollRef = useRef(0)
  const scrollTopRef = useRef(0)
  useAnimationFrame(deltaTime => {
    const top = useStore.getState().top
    if(scrollRef.current) scrollRef.current.innerText = top.toFixed(4)
    if(scrollTopRef.current) scrollTopRef.current.innerText = `${useStore.getState().scrollTop.current} + ${window.innerHeight}`
  })
  return (
    <div className="debug">
      <li>scroll: <span ref={scrollRef} /></li>
      <li>scrollTop: <span ref={scrollTopRef} /></li>
    </div>
  )
}